export const WSE = {
// client → serveur
JOIN_QUEUE: "join_queue",
ANSWER: "answer",


// serveur → client
CONNECTION_SUCCESS: "connection_success",
PLAYERS_COUNT: "players_count",
START_GAME: "start_game",
ROUND_START: "round_start",
ROUND_END: "round_end",
GAME_OVER: "game_over",
ERROR: "error",
};
